import React from 'react';

import styles from './PaymentForm.module.scss';

/**
 * Web port of CostCircle (the dashed-circle price display). The original
 * used a dashed-circle PNG asset (dashedCircleSource) with price text
 * absolutely positioned over it; recreated here as an SVG dashed circle so
 * no image asset is needed.
 */
const CostCircle = ({ price = 0, text }) => (
  <div className={styles.costCircleWrap}>
    <svg viewBox="0 0 152 152" className={styles.costCircleSvg}>
      <circle cx="76" cy="76" r="70" fill="none" stroke="#e53935" strokeWidth="3" strokeDasharray="6 6" />
    </svg>
    <div className={styles.costCircleTextWrap}>
      <span className={styles.costCirclePrice}>${price}</span>
      <span className={styles.costCircleTax}>{text}</span>
    </div>
  </div>
);

export default CostCircle;